<div class="information-dialog modified-offer-price-change-dialog">
    <h2 class="information-dialog__header">{{getTranslationKey('header') | translate | uppercase}}</h2>
    <img class="information-dialog__image" [src]="imageSrc" alt="">
    <div class="modified-offer-price-change-dialog__text">
        <div>{{getTranslationKey('recalculatedOfferInformation') | translate}}</div>
        <div class="modified-offer-price-change-dialog__text__policy-price">
            {{getTranslationKey('policyPriceInformation') | translate}} -
            <app-offer-modification-price [price]="policyPrice"></app-offer-modification-price>
        </div>
        <div *ngFor="let instalment of instalmentsValues; let i = index">
            {{ i+1 }} {{ 'MODIFIED_OFFER_PRICE_CHANGE_DIALOG_COMPONENT.installment' | translate }} -
            <app-offer-modification-price [price]="instalment"></app-offer-modification-price>
        </div>
    </div>

    <div class="modified-offer-price-change-dialog__buttons">
        <button (click)="backToOffer()" class="btn btn--primary btn--big">
            {{getTranslationKey('backToOffer') | translate}}
        </button>

        <button (click)="buyOnline()" class="btn btn--secondary btn--big">
            {{getTranslationKey('buyOnline') | translate}}
        </button>
    </div>

</div>
